module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAVCAYAAABPPm7SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACOSURBVHgB7ZTBDYAgDEWLcQBGYBRXcAM3cAU3cRTdQDfADXSD+msw4VbAeOMlHw6kjxCgRICZR+TkPDbEGRng8MgVkopDVtm9C8Y5o5hCjW/oI1VQBf8L8FRt+CtlArAgHpKhVKDSKus9Yo0xe5EAhQcpxA1FUAsiHElDESCZOB//tLRXJ1eGyaZu/x7vBsSWpOI6KaiDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/icon-phone.png
// module id = 0CH/
// module chunks = 0